var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppSubstanceReviewer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 14.4297H14.9312C20.8838 14.4297 24.5068 17.4639 24.5068 22.8662C24.5068 26.4924 22.6211 28.6387 20.292 29.8599L25.7271 39.2214H18.2588L14.044 31.2659H12.3799V39.1843H5.91017L5.91016 14.4297ZM12.3799 25.4194L15.227 25.3826C16.8535 25.3826 17.8887 24.4575 17.8887 22.9402C17.8887 21.6081 17.2607 20.3872 15.2637 20.3872H12.3799V25.4194Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4526 19.906C33.0073 23.6064 33.4883 27.4546 34.0059 31.2287C34.5601 27.6025 35.1885 23.9394 35.7061 20.3501L40.7344 20.3872C41.3262 24.0134 41.9546 27.6765 42.5459 31.3769C42.9531 27.5286 43.5073 23.7173 43.9883 19.906H49.6445L45.9106 39.1843L40.0322 39.2214L38.1836 29.7117L36.335 39.2214H30.1973L26.2783 19.906H32.4526Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppSubstanceReviewer);
export default __webpack_public_path__ + "static/media/B_app_SubstanceReviewer.71b4e18c11256a7a00c27ccc1781ef15.svg";
export { ForwardRef as ReactComponent };